module.exports = __webpack_public_path__ + "static/fundwall_thumbnail-a1e1ad239b629eae1880aa700a869173.jpg";